__turbopack_context__.v({
  "btnWrp": "styles-module__cZ4Eea__btnWrp",
  "linkWrp": "styles-module__cZ4Eea__linkWrp",
  "logoWrp": "styles-module__cZ4Eea__logoWrp",
  "secondHeadContent": "styles-module__cZ4Eea__secondHeadContent",
  "secondHeadWrap": "styles-module__cZ4Eea__secondHeadWrap",
  "secondHeadWrapLight": "styles-module__cZ4Eea__secondHeadWrapLight",
});
